<app-nav></app-nav>

<section class="container-fluid we_are_anima">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-8 d-flex justify-content-end">
                <h2>
                    {{"about.title" | translate}}
                </h2>
            </div>
            <div class="col-12 col-md-1">
            </div>
            <div class="col-3">
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-8 text d-flex align-items-end mb-5">
                <p class="pad">
                    {{"about.p1" | translate}}
                </p>
                <p class="pad">
                    {{"about.p2" | translate}}
                </p>

                <div class="accent">
                    <p>
                        {{"about.accent" | translate}}
                    </p>
                </div>
                <p class="pad">
                    {{"about.p3" | translate}}
                </p>
                <p class="pad">
                    {{"about.p4" | translate}}
                </p>
                <div class="line"></div>
            </div>
            <div class="col-12 col-md-1 ">
            </div>
            <div class="col-12 col-md-3 sidebar ">
                <div class="share">
                    <app-result-share-links class="mb-4"></app-result-share-links>
                    <ng-container *ngIf="!subscribed; else uns">
                        <input type="email" placeholder="mailto:yourmail@gmail.com"/>
                        <div class="agree">
                            <input type="checkbox" name="checkbox"/>
                            <span>I agree to the terms and conditions</span>
                        </div>
                        <button class="action hover_action" (click)="subscribe()">
                            <span>
                                {{'global.subscribe' | translate}}</span>
                            <img src="./assets/img/chevron-right.svg" alt="chevron-right">
                        </button>
                    </ng-container>
                    <ng-template #uns>
                        <button class="action hover_action" (click)="unsuscribe()">
                            <span>{{'global.unsubscribe' | translate}}</span>
                            <img src="./assets/img/chevron-right.svg" alt="chevron-right">
                        </button>
                    </ng-template>
                </div>
                <div class="d-flex justify-content-end mb-5">
                    <picture class="main-img">
                        <source media="(max-width: 799px)" srcset="assets/img/mon1_1x.webp"/>
                        <source media="(min-width: 800px)" srcset="assets/img/mon1_2x.webp"/>
                        <img src="assets/img/mon1_2x.webp" alt="anima monitor"/>
                    </picture>
                </div>
                <div></div>
            </div>
        </div>
    </div>
</section>
<section class="container-fluid ">
    <div class="container">
        <div class="row mb-4">
            <div class="col-12 col-md-8 d-flex justify-content-end">
                <h2>
                    {{"about.title-partners" | translate}}
                </h2>
            </div>
            <div class="col-12 col-md-1">
            </div>
            <div class="col-12 col-md-3"></div>
        </div>
        <div class="row">
            <div class="col-12 col-md-2"></div>
            <div class="col-12 col-md-7">
                <div class="partners">
                    <div class="partners-item">
                        <div class="logo">
                            <img src="./assets/img/bee.png">

                        </div>
                        <div class="text">
                            <p>
                                {{"about.p-b" | translate}}
                            </p>
                        </div>
                    </div>

                    <div class="partners-item">
                        <div class="logo">
                            <img src="./assets/img/ai.png">

                        </div>
                        <div class="text">
                            <p>
                                {{"about.p-a" | translate}}
                            </p>
                        </div>
                    </div>

                    <div class="partners-item">
                        <div class="logo">

                            <img src="./assets/img/vh.png">
                        </div>
                        <div class="text">
                            <p>
                                {{"about.p-v" | translate}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3"></div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-2">
            </div>
            <div class="col-12 col-md-10">
                <div class="row mb-2">
                    <div class="col-12 col-md-4">
                        <div class="d-flex align-items-end mb-5">
                            <picture>
                                <source media="(max-width: 799px)" srcset="assets/img/danilov_1x.webp"/>
                                <source media="(min-width: 800px)" srcset="assets/img/danilov_2x.webp"/>
                                <img width="110px" src="assets/img/danilov_2x.webp" alt="Serhiy Danilov"/>
                            </picture>

                            <p class="m-0 ml-3">
                                <b>
                                    {{"about.danilov-name" | translate}}
                                  </b><br>
                                <small>
                                    {{"about.danilov" | translate}}
                                </small>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 border-left quote-text">
                        <svg class="quote-icon" width="43" height="34" viewBox="0 0 43 34" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.4 33.1V12.1C25.4 2.3 32.1 -9.53674e-07 35.6 -9.53674e-07H42.8V9H39.2C35.5 9 34.9 11.7 34.9 12.7V16.1H42.8V33.1H25.4ZM0.7 33.1V12.1C0.7 2.3 7.4 -9.53674e-07 10.9 -9.53674e-07H18.1V9H14.5C10.7 9 10.2 11.8 10.2 12.7V16.1H18.1V33.1H0.7Z"
                                  fill="#10082F"/>
                        </svg>
                       {{"about.q1" | translate}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-3">
            </div>
            <div class="col-12 col-md-6 mb-2">
                <p>
                    {{"about.p5" | translate}}
                    </p>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-2">
            </div>
            <div class="col-12 col-md-10">
                <div class="row mb-2">
                    <div class="col-12 col-md-4">
                        <div class="d-flex align-items-end mb-5">
                            <picture>
                                <source media="(max-width: 799px)" srcset="assets/img/havrysh_1x.webp"/>
                                <source media="(min-width: 800px)" srcset="assets/img/havrysh_2x.webp"/>
                                <img width="110px" src="assets/img/havrysh_2x.webp" alt="Roman Havrysh"/>
                            </picture>
                            <p class="m-0 ml-3">
                                <b>
                                    {{"about.havrysh-name" | translate}}
                                </b><br>
                                <small>
                                    {{"about.havrysh" | translate}}
                                </small>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 border-left quote-text">
                        <svg class="quote-icon" width="43" height="34" viewBox="0 0 43 34" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.4 33.1V12.1C25.4 2.3 32.1 -9.53674e-07 35.6 -9.53674e-07H42.8V9H39.2C35.5 9 34.9 11.7 34.9 12.7V16.1H42.8V33.1H25.4ZM0.7 33.1V12.1C0.7 2.3 7.4 -9.53674e-07 10.9 -9.53674e-07H18.1V9H14.5C10.7 9 10.2 11.8 10.2 12.7V16.1H18.1V33.1H0.7Z"
                                  fill="#10082F"/>
                        </svg>
                        {{"about.q2" | translate}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-9 d-flex justify-content-end">
                <picture class="main-img">
                    <source media="(max-width: 799px)" srcset="assets/img/prof_1x.webp"/>
                    <source media="(min-width: 800px)" srcset="assets/img/prof_2x.webp"/>
                    <img src="assets/img/prof_2x.webp" alt="anima monitor"/>
                </picture>
            </div>
            <div class="col-12 col-md-3">
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-8 mb-2 d-flex justify-content-end">
                <p class="pad">
                    {{"about.p6" | translate}}
                </p>
            </div>
            <div class="col-12 col-md-1"></div>
            <div class="col-12 col-md-3">
                <picture>
                    <source media="(max-width: 799px)" srcset="assets/img/mon2_1x.webp"/>
                    <source media="(min-width: 800px)" srcset="assets/img/mon2_2x.webp"/>
                    <img src="assets/img/mon2_2x.webp" alt="anima monitor"/>
                </picture>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>
